import { FC } from 'react';
import { Typography, Grid } from '@mui/material';
import { FormPublicDesignFragment } from 'graphql/fragment/form.public.fragment';
import AndrewKlajbor from '../assets/andrewklajbor.jpg';
import AnthonyJardim from '../assets/anthonyjardim.jpg';
import MenesKum from '../assets/meneskum.jpg';
import VincentAttonito from '../assets/vincentattonito.jpg';
import Supporter from './Supporter';

interface Props {
  design: FormPublicDesignFragment;
}

const ContactUs: FC<Props> = ({ design }) => {
  return (
    <>
      <Grid item xs={12} sx={{ margin: '40px 0' }}>
        <Typography variant='h6' color='white' align='center'>
          For more information, please contact us:
        </Typography>
      </Grid>
      <Grid item xs={0} md={2}></Grid>
      <Grid item xs={12} md={4} sx={{ marginBottom: '30px' }}>
        <Supporter
          name='Anthony Jardim'
          position='Principal'
          email='ajardim@deloitte.com'
          picture={AnthonyJardim}
          design={design}
        />
      </Grid>
      <Grid item xs={12} md={4} sx={{ marginBottom: '30px' }}>
        <Supporter
          name='Menes Etingue Kum'
          position='Senior Manager'
          email='metinguekum@deloitte.com'
          picture={MenesKum}
          design={design}
        />
      </Grid>
      <Grid item xs={0} md={2}></Grid>
      <Grid item xs={0} md={2}></Grid>
      <Grid
        item
        xs={12}
        md={4}
        sx={{ marginBottom: ['30px', '30px', '100px'] }}
      >
        <Supporter
          name='Vincent Attonitto'
          position='Manager'
          email='vattonito@deloitte.com'
          picture={VincentAttonito}
          design={design}
        />
      </Grid>
      <Grid item xs={12} md={4} sx={{ marginBottom: '100px' }}>
        <Supporter
          name='Andrew Klajbor'
          position='Senior Manager'
          email='aklajbor@deloitte.com'
          picture={AndrewKlajbor}
          design={design}
        />
      </Grid>
      <Grid item xs={0} md={2}></Grid>
    </>
  );
};

export default ContactUs;
